module.exports = __webpack_public_path__ + "img/down-arrow-swirl-blue.27a25c36.svg";